<div [class]="FORM_STYLE_CONFIG.formGroup.portlet.body.section.default">
	<div
		[class]="
			FORM_STYLE_CONFIG.formGroup.portlet.body.section.heading.default
		"
		ngClass="row flex-row"
	>
		<h3
			[class]="
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.heading.header
					.default
			"
			ngClass="col-md-8"
		>
			Sector Targets:
			<span class="red">*</span>
		</h3>
		<div class="create-batch-button col-md-4">
			<div class="float-right">
				<button
					*ngIf="editingOrFilling && !disable"
					type="button"
					(click)="openAddSectorForm()"
					class="
						btn btn-secondary
						m-btn m-btn--custom m-btn--outline-2x
					"
				>
					Add Sector Targets
				</button>
			</div>
		</div>
	</div>
	<app-table [table]="sectorTargetTable"></app-table>
</div>

<div
	*ngIf="selectedSchemeId"
	class="modal fade show add-preference-role-div"
	[id]="MODAL_ID.ADD_SECTOR_TARGET"
	tabindex="-1"
	role="dialog"
	aria-labelledby="exampleModalLabel"
	style="padding-right: 17px"
>
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">
					Add Sector Targets
				</h5>
				<button
					type="button"
					class="close"
					data-dismiss="modal"
					aria-label="Close"
				>
					<span aria-hidden="true">×</span>
				</button>
			</div>
			<div class="modal-body padding-top-null padding-bottom-null">
				<app-add-sector-target-form
					[trainingCentreName]="trainingCentreName"
					[selectedCourses]="selectedCourses"
					[sectorTargetTable]="sectorTargetTable"
					[selectedSchemeId]="selectedSchemeId"
					(submit)="addSectorTarget($event)"
				></app-add-sector-target-form>
				<!-- <app-add-course-to-sector [resetVersion]="resetVersion" [label]="sectorLabel" [(sectors)]="sectors" (verify)="addCourseToSector($event)"></app-add-course-to-sector> -->
			</div>
		</div>
	</div>
</div>
